import styled from '@emotion/styled';
import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import * as S from 'src/modules/programs/stepComponents/styles';
import stepIcon from 'src/public/img/diagram-emotional-distress-process-explained@3x.png';

const StepIcon = styled('img')({
    display: 'block',
    width: '20rem',
    margin: '0 auto',
});

export const WhatDoesThisLookLikeStep = withTranslation('cbt')(({ t }: WithTranslation) => (
    <>
        <S.ContentRow>
            <S.ContentColumn>
                <S.StepHeading>{t('week-1.what-does-this-look-like.title')}</S.StepHeading>
            </S.ContentColumn>
        </S.ContentRow>
        <S.ContentRow>
            <S.ContentColumn md={14}>
                <S.StepDescription small>
                    {t('week-1.what-does-this-look-like.description')}
                </S.StepDescription>
            </S.ContentColumn>
            <S.ContentColumn md={10}>
                <StepIcon src={stepIcon} />
            </S.ContentColumn>
        </S.ContentRow>
    </>
));
